import { format } from '@office-start/string-formatter-utility';
import { isNullOrWhitespace } from '../helpers/isNullOrWhitespace';
export function generateGreetings(locStrings, userGreetingName, isSecondRun) {
    if (userGreetingName === void 0) { userGreetingName = ''; }
    var greetings;
    if (isSecondRun) {
        var greetingHeaderNoName = locStrings.secondRunGeneralResources.greetingHeaderNoName;
        greetings = [greetingHeaderNoName];
    }
    else {
        var _a = locStrings.firstRunGeneralResources, greetingText1 = _a.greetingText1, greetingText1WithUserName = _a.greetingText1WithUserName, greetingText2 = _a.greetingText2;
        greetings = [
            isNullOrWhitespace(userGreetingName)
                ? greetingText1
                : format(greetingText1WithUserName, userGreetingName),
            greetingText2,
        ];
    }
    return greetings;
}
//# sourceMappingURL=generateGreetings.js.map